<section class="section" id="about">
	<div class="inner">
		<p class="section-label">Our Mission</p>
		<h2 class="section-title">About SkinGenie</h2>
		<p class="about-content">
			At SkinGenie, we combine cutting-edge AI with the science of skincare to offer personalized skincare solutions. Our journey began in Austin, Texas, with a mission to connect our users to products that actually work for them.
		</p>
	</div>
</section>


<style>
	/* Local .section-label / .section-title are gone; both headings now use the
	   shared primitives in global.css, so all landing sections align. */
	.section {
		padding: var(--section-gap) var(--page-pad-x);
		background: var(--bg);
	}


	.inner {
		max-width: var(--content-max);
		margin: 0 auto;
	}

	/* The shared .section-title parks --section-gap below itself, which
	   double-counts against this section's own --section-gap padding. Type,
	   colour and alignment stay from the primitive; only the trailing space
	   is re-parked, identically in all four landing sections. */
	.section-title {
		margin-bottom: var(--space-12);
	}

	.about-content {
		max-width: var(--prose-max);
		margin: 0 auto;
		text-align: center;
		font-size: var(--text-md);
		font-weight: var(--weight-light);
		line-height: var(--leading-relaxed);
		color: var(--text-muted);
	}


	/* Two-column grid instead of absolute positioning plus a padding-left
	   hack, so the numeral and the copy stay aligned at any width. */



</style>
